export const FilePickerDefaultOptions = {
  maxSize: 15 * 1024 * 1024 * 1024, // 15 GB in Bytes
  maxFiles: 30,
};
